import { usePicoXTrack } from '@eventbrite/bsp-sdk/react';
import { useEffect } from 'react';
import { PicoXPayloadValue } from './picoxInteractionsMapper';

type PicoXTrackFn = (name: string, payload?: Record<string, PicoXPayloadValue>) => void;

let capturedTrack: PicoXTrackFn | null = null;

/**
 * Captures BSP's React-only PicoX tracking callback into a module-level
 * reference so the document-level `EventsInteractionsTracker` (which is not a
 * React component) can emit PicoX events after its impression dedupe, via
 * `trackPicoXEvent`.
 *
 * Must be called from a component under `BspProvider` (the homepage mounts it in
 * `pages/_app.page.tsx`); `useTracking` calls it. Ported from eb-ui
 * `packages/attendee/ads/src/tracking/picoxTrackBridge.tsx`.
 */
export const usePicoXTrackBridge = () => {
    const track = usePicoXTrack();

    useEffect(() => {
        const captured = track as PicoXTrackFn;
        capturedTrack = captured;

        return () => {
            if (capturedTrack === captured) {
                capturedTrack = null;
            }
        };
    }, [track]);
};

export const trackPicoXEvent = (name: string, payload?: Record<string, PicoXPayloadValue>) => {
    capturedTrack?.(name, payload);
};
